import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  AddGiftCardProductCartRootParamList,
  RegisterRootParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { AddGiftCardProductScreen } from "./AddGiftCardProductScreen";
import { SearchOrAddGiftCardScreen } from "./SearchOrAddGiftCardScreen";
import { AddGiftCardScreenContext } from "./context";
import { GenerateGiftCardCodeScreen } from "./GenerateGiftCardCodeScreen";

const Stack = createStackHeaderNavigator<AddGiftCardProductCartRootParamList>();

export interface AddGiftCardProductCartRootScreenProps
  extends StackScreenProps<
    RegisterRootParamList,
    "AddGiftCardProductCartRootScreen"
  > {}

export const AddGiftCardProductCartRootScreen = ({
  route,
}: AddGiftCardProductCartRootScreenProps) => {
  const { productId } = route.params;

  return (
    <AddGiftCardScreenContext.Provider value={{ productId }}>
      <Stack.Navigator
        screenOptions={{
          headerShown: true,
          title: ``,
          headerLeft: () => <ModalCloseButton type="Close" />,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Screen
          name="SearchOrAddGiftCardScreen"
          component={SearchOrAddGiftCardScreen}
        />
        <Stack.Screen
          name="AddGiftCardProductScreen"
          component={AddGiftCardProductScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        />
        <Stack.Screen
          name="GenerateGiftCardCodeScreen"
          component={GenerateGiftCardCodeScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        />
      </Stack.Navigator>
    </AddGiftCardScreenContext.Provider>
  );
};
